import React from 'react'
import Nav from '../Home/Nav/Nav.js';
import { FaLongArrowAltLeft } from "react-icons/fa";
import { Link as RouterLink } from 'react-router-dom';
import { CiInstagram } from "react-icons/ci";
import { CiFacebook } from "react-icons/ci";
import './ContactPage.css';
import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const { t, i18n } = useTranslation();
   const handleSubmit = (e) => {
    e.preventDefault();
          const changeLanguage = (e) => {
            i18n.changeLanguage(e.target.value);
        };
    // 1. Get data from the form
    const formData = new FormData(e.target);
    const nom = formData.get('Nom');
    const prenom = formData.get('Prenom');
    const sujet = formData.get('Sujet');
    const message = formData.get('Message');

    // 2. Define the recipient
    const emailTo = "contact@musee-loukach.ma";

    // 3. Construct the body (optional: adding the sender's name)
    const body = `Nom: ${nom} ${prenom}\n\nMessage:\n${message}`;

    // 4. Create the mailto link 
    // encodeURIComponent ensures special characters (like spaces) work in a URL
    const mailtoLink = `mailto:${emailTo}?subject=${encodeURIComponent(sujet)}&body=${encodeURIComponent(body)}`;

    // 5. Open the mail app
    window.location.href = mailtoLink;
  };
  return (
    <div>
      <div className='contactp'>
        <div className='pt-10' ><Nav /></div>
        <div className='contactp_all'>
          <div className='contactp_titles titre'>
            <h1>{t('contact.grand_title')}</h1>
          </div>
          <div className='buttons'>
            <RouterLink to="/" className='contactp_button2 plf'>
              <FaLongArrowAltLeft />
              {t('contact.b1')}
            </RouterLink>
          </div>
        </div>
      </div>
      <div>
        <div 
  className='
    flex flex-col lg:flex-row 
    mx-auto                
    bg-no-repeat bg-left mt-2 
    max-w-7xl              
    px-4 lg:px-8 py-5 sm:p-8 
    justify-around gap-8 
    rounded-3xl lg:rounded-[60px]  
  '
>
          <section
            className='flex flex-col items-center   lg:items-start text-center lg:text-left lg:flex-shrink-0 lg:max-w-md p-4 lg:p-0'>
            <div
              className='flex  flex-col justify-evenly gap-6 max-w-4xl  mx-auto '
            >
              <h1 className='text-[#723C3C] ct font-[Font6] text-3xl sm:text-4xl lg:text-5xl titre'>
                {t('contact.subtitle')}
              </h1>

              <p className='font-[reg] plf text-black ct text-base sm:text-xl lg:text-2xl mt-2 max-w-full  lg:max-w-md'>
                {t('contact.paragraph')}
              </p>

              <img src='/assets/icons/Frame.png' alt="Frame_contact" className="w-2/3 sm:w-1/2 mx-auto lg:w-full max-w-xs my-6" />
            </div>

            <div className='contact_infos text-sm  sm:text-base'>
              {/* <p className='leading-8'><strong className='text-lg leading-tight text-[#243462] font-bold'>Telephone</strong> </p>
              <p className='leading-8'>+212 500 00 00 00</p> */}
              <p className='leading-8'><strong className='text-lg plf leading-tight text-[#243462] font-bold'>{t('contact.email')}</strong></p>
              <p className='leading-8 plf'>{t('contact.email_value')}</p>
              <p className='leading-8'><strong className='text-lg plf leading-tight text-[#243462] font-bold'>{t('contact.adresse')}</strong></p>
              <p className='leading-8 plf'>{t('contact.adresse_value')}</p>

              <div className='flex justify-center lg:justify-start gap-4 mt-3'>
                <a href='https://www.facebook.com/' className='text-black text-3xl'><CiFacebook /></a>
                <a href='https://www.instagram.com/museeloukach/?igsh=OGlma2hhb25sM3pr#' className='text-black text-3xl'><CiInstagram /></a>
              </div>
            </div>
          </section>

          <section className='border-2 border-blue-400/60 bg-[#F3EFDD]  rounded-3xl w-full lg:max-w-xl'>

            <div className='map'>
              <div className="embed-map-responsive">
                <div className="embed-map-container">
                  <iframe title='iframe' className="embed-map-frame" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=600&height=400&hl=en&q=Madrasa%20Loukach&t=&z=13&ie=UTF8&iwloc=B&output=embed">
                  </iframe>
                </div>
              </div>
            </div>

            <form className='p-4 lg:p-8' onSubmit={handleSubmit} >

              <div className="flex flex-col sm:flex-row gap-4 mb-2">
                <input type="text" id="Nom" name="Nom" placeholder={t('contact.form_nom')} required
                  className="bg-[#E9E9E9] border-none rounded-full h-10 px-4 shadow-md w-full sm:w-1/2" />
                <input type="text" id="Prenom" name="Prenom" placeholder={t('contact.form_prenom')} required
                  className="bg-[#E9E9E9] border-none rounded-full h-10 px-4 shadow-md w-full sm:w-1/2" />
              </div>
              <input type="text" id="Sujet" name="Sujet" placeholder={t('contact.form_sujet')} required
                className='bg-[#E9E9E9] border-none rounded-full h-10 px-4 shadow-md w-full mb-4' />
              <textarea id="Message" name="Message" rows="6" placeholder={t('contact.form_message')}
                className="bg-[#E9E9E9] border-none rounded-xl p-4 shadow-md w-full resize-y mb-4"></textarea>
              <button type="submit"
                className="bg-[#C5A274] plf text-white py-3 px-5 border-none rounded-full text-sm font-bold cursor-pointer transition duration-300 hover:bg-[#a58661]">
                {t('contact.form_button')}
              </button>
            </form>
          </section>
        </div>
      </div>
    </div>
  )
}

export default ContactPage